import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c81e5c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progress-overlay__icon" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progress-overlay__content" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Verification in progress"),
  /*#__PURE__*/_createElementVNode("p", null, " We are verifying your workstation based on the details provided. This may take up to 72h. You are still able to look around your workstation but cannot use some areas until the verification has been completed. You’ll receive an email as soon as verification is complete. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressIcon = _resolveComponent("ProgressIcon")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["progress-overlay progress-w-8", $props.className])
    }, null, 2),
    _createVNode(_component_v_card, { class: "progress-overlay__card md:!tw-w-[80%]" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_ProgressIcon)
        ]),
        _hoisted_2
      ]),
      _: 1
    })
  ], 64))
}